import { useForm, Controller } from "react-hook-form";
import { useEffect, useState } from "react";
import api from "service/api";
import { toast } from "react-toastify";
import { NavLink } from "react-router-dom";
import PaginationComponent from "components/Pagination/Pagination";
import ModalConfirm from "../components/Modal/ModalConfirm";
import usePagination from "hooks/usepagination";
import Select from "react-select";
import { CookieTool } from "utils/CookieTool";
import {
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Form,
  Button,
  CardTitle,
  Col,
  CardBody,
  FormGroup,
} from "reactstrap";

const Libraries = () => {
  const { register, handleSubmit, control, reset, setValue, getValues } =
    useForm();
  const [, setCollapseOpen] = useState();
  const [info, setInfo] = useState([]);
  const { actualPage } = usePagination();
  const [offset, setOffset] = useState(actualPage || 1);
  const [, setOnLoad] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(100);
  const [, setDisabled] = useState(false);
  const [clients, setClients] = useState([]);
  const [showGeneralLibraries, setShowGeneralLibraries] = useState(false);

  const userClientId = CookieTool.get("admin_client_id");
  const userClient = CookieTool.get("admin_client");
  const userPermissions = CookieTool.getLarge("permissions");

  useEffect(() => {
    setOnLoad(true);
    api
      .get(`/libraries?page=${offset}&limit=${Number(limit)}&${search}`)
      .then((response) => response.data)
      .then((response) => {
        if (!response.total || response.records.length === 0) {
          toast.info("Nenhuma biblioteca encontrada!");
          setInfo([]);
          setTotalCount(0);
          setTotalPages(0);
          setOnLoad(false);
          return;
        }
        setTotalPages(Math.ceil(response.total / limit));
        setTotalCount(response.total);
        setInfo(response.records);
        setOnLoad(false);
      })
      .catch(() => {
        toast.error("Erro ao recuperar bibliotecas!");
        return;
      });

    if (userClient) {
      setValue("client", {
        value: userClientId,
        label: userClient,
      });
    } else {
      api
        .get(`/clients?page=1&limit=10000`)
        .then((response) => {
          setClients(
            response.data.clients.map((item) => ({
              label: item.name,
              value: item.id,
            })),
          );
        })
        .catch(() => {
          toast.error("Erro ao recuperar clientes!");
          return;
        });
    }
  }, [offset, search, limit]);

  const handleDelete = (id) => {
    setDisabled(true);
    api
      .delete(`/library/${id}`)
      .then(() => {
        toast.success("Biblioteca deletada com sucesso!");
        const infoFilter = info.filter((item) => item.id !== id);
        setInfo(infoFilter);
        setDisabled(false);
      })
      .catch((e) => {
        if (e.response?.status === 409) {
          toast.error(
            "A biblioteca não pode ser excluída! Ela está sendo utilizada como referencia.",
          );
        }
        setDisabled(false);
      });
  };

  const onSubmit = (data) => {
    const { title, client } = data;
    let query = "";
    if (title) {
      query += `title=${title}&`;
    }
    if (client) {
      query += `clientId=${client.value}&`;
    }
    query += `showGeneralLibraries=${showGeneralLibraries}&`;
    setSearch(query);
  };

  const clearSearch = () => {
    setSearch("");
    reset();
    setShowGeneralLibraries(false);
  };

  const closeCollapse = () => {
    setCollapseOpen(false);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  const handleShowGeneralLibrariesChange = (checked) => {
    setShowGeneralLibraries(checked);
    if (checked) {
      setValue("client", null);
    }
  };

  return (
    <>
      <Container className="mt-2" fluid>
        <div className="header bg-gradient-info pb-8 pt-2 pt-md-2 d-flex align-items-center justify-content-center flex-column rounded">
          <div className="container-fluid">
            <h1>Bibliotecas</h1>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col lg={3}>
                  <FormGroup>
                    <label className="text-white mr-2 ml-2">Cliente</label>
                    <Controller
                      name="client"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          className="basic-single"
                          classNamePrefix="select"
                          placeholder="Selecione um cliente"
                          isClearable={true}
                          isSearchable={true}
                          isDisabled={userClient || showGeneralLibraries}
                          options={clients}
                          value={getValues("client")}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption);
                          }}
                        />
                      )}
                    />
                  </FormGroup>
                </Col>
                <Col lg={3} className="align-items-center">
                  <FormGroup>
                    <label className="text-white mr-2 ml-2">Título</label>
                    <input
                      type="text"
                      className="form-control custom-input"
                      placeholder="Digite aqui"
                      style={{
                        display: "block",
                        width: "100%",
                        height: "calc(1.2em + 1.25rem + 2px)",
                        padding: "0.625rem 0.75rem",
                        fontSize: "0.875rem",
                        fontWeight: "400",
                        lineHeight: "1.5",
                        color: "#8898aa",
                        backgroundColor: "#fff",
                        backgroundClip: "padding-box",
                        border: "1px solid #cad1d7",
                        borderRadius: "0.275rem",
                      }}
                      {...register("title")}
                    />
                  </FormGroup>
                </Col>
                <Col lg={3} className="align-items-center d-flex">
                  <FormGroup className="d-flex align-items-center">
                    <input
                      type="checkbox"
                      className="form-control custom-checkbox mr-2"
                      style={{ width: "20px", height: "20px" }}
                      checked={showGeneralLibraries}
                      onChange={(e) =>
                        handleShowGeneralLibrariesChange(e.target.checked)
                      }
                    />
                    <label className="text-white mb-0">
                      Exibir apenas bibliotecas gerais
                    </label>
                  </FormGroup>
                </Col>
                <Col
                  lg={2}
                  className="justify-content-start d-flex flex-row align-items-end"
                >
                  <FormGroup>
                    <Button
                      className="Button ml-2"
                      type="submit"
                      style={{ height: "44px" }}
                    >
                      Buscar
                    </Button>
                  </FormGroup>
                  <FormGroup>
                    <Button
                      className="Button ml-4"
                      onClick={clearSearch}
                      style={{ height: "44px" }}
                    >
                      Limpar
                    </Button>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col lg="6" xl="3">
                  <Card className="card-stats mb-4 mb-xl-0">
                    <CardBody className="pb-1">
                      <Row>
                        <div className="d-flex flex-row align-items-center">
                          <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0 mr-2"
                          >
                            Registros:
                          </CardTitle>
                          <span className="h2 font-weight-bold mb-0">
                            {totalCount}
                          </span>
                        </div>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="6" xl="3">
                  <Card className="card-stats mb-4 mb-xl-0">
                    <CardBody className="pb-1 ">
                      <Row>
                        <div className="d-flex flex-row align-items-center">
                          <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0 mr-2"
                          >
                            Páginas:
                          </CardTitle>
                          <span className="h2 font-weight-bold mb-0">
                            {totalPages}
                          </span>
                        </div>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </Container>
      {/* Page content */}
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow rounded-0">
              <CardHeader className="border-0 d-flex ml-2">
                <select
                  style={{
                    display: "block",
                    width: "80px",
                    height: "35px",
                    fontSize: "0.875rem",
                    lineHeight: "1.5",
                    color: "#8898aa",
                    backgroundColor: "#fff",
                    backgroundClip: "padding-box",
                    border: "1px solid #cad1d7",
                    borderRadius: "0.275rem",
                    boxShadow: "none",
                  }}
                  name="limit"
                  id="limit"
                  className="Input"
                  value={limit}
                  onChange={handleLimitChange}
                >
                  <option value="10">10</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th>Título</th>
                    <th>Descrição</th>
                    <th>Cliente</th>
                    {userPermissions?.includes("update:library") && (
                      <th>Editar</th>
                    )}
                    {userPermissions?.includes("remove:library") && (
                      <th>Excluir</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {info?.map((item) => (
                    <tr key={item.id}>
                      <td className="truncate-text-field" title={item.title}>
                        {item.title}
                      </td>
                      <td
                        className="truncate-text-field"
                        title={item.description}
                      >
                        {item.description}
                      </td>
                      <td>{item.client_name ?? "N/A"}</td>
                      {userPermissions?.includes("update:library") && (
                        <td>
                          <NavLink
                            to={`/admin/library-form?id=${item.id}`}
                            onClick={closeCollapse}
                            activeClassName="active"
                          >
                            Editar
                          </NavLink>
                        </td>
                      )}
                      {userPermissions?.includes("remove:library") && (
                        <td>
                          <ModalConfirm
                            id={item.id}
                            modalText={`Esta ação irá excluir a biblioteca ${item.title}, você tem certeza?`}
                            handler={() => {
                              handleDelete(item.id);
                            }}
                            icon={"fas fa-trash"}
                          />
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <nav aria-label="...">
                  <PaginationComponent
                    limit={limit}
                    total={totalPages}
                    offset={offset}
                    setOffset={setOffset}
                  />
                </nav>
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Libraries;
